import { IPage, Page } from './Page';
import { ISection, Section } from './Section';
import { Column, IColumn } from './Column';
import { IText, Text } from './Text';
import { IImage, Image } from './Image';
import { Group, IGroup } from './Group';
import { Button, IButton } from './Button';
import { Divider, IDivider } from './Divider';
import { IWrapper, Wrapper } from './Wrapper';
import { ISpacer, Spacer } from './Spacer';
import { Carousel, ICarousel } from './Carousel';
import { Hero, IHero } from './Hero';
import { INavbar, Navbar } from './Navbar';
import { ISocial, Social } from './Social';
import { IRaw, Raw } from './Raw';
import { ITemplate, Template } from './Template';
import { ITable, Table } from './Table';

import { Accordion, IAccordion } from './Accordion';
import { AccordionElement, IAccordionElement } from './AccordionElement';
import { AccordionTitle, IAccordionTitle } from './AccordionTitle';
import { AccordionText, IAccordionText } from './AccordionText';
import { BasicType } from '../../constants';
import { ITableColumn, TableColumn } from './TableColumn';
import { ITableRow, TableRow } from './TableRow';

export const standardBlocks = {
    [BasicType.PAGE]: Page,
    [BasicType.SECTION]: Section,
    [BasicType.COLUMN]: Column,
    [BasicType.TEXT]: Text,
    [BasicType.IMAGE]: Image,
    [BasicType.GROUP]: Group,
    [BasicType.BUTTON]: Button,
    [BasicType.DIVIDER]: Divider,
    [BasicType.WRAPPER]: Wrapper,
    [BasicType.SPACER]: Spacer,
    [BasicType.RAW]: Raw,
    [BasicType.CAROUSEL]: Carousel,
    [BasicType.HERO]: Hero,
    [BasicType.NAVBAR]: Navbar,
    [BasicType.SOCIAL]: Social,
    [BasicType.TABLE]: Table,
    [BasicType.TABLE_COLUMN]: TableColumn,
    [BasicType.TABLE_ROW]: TableRow,

    // spacial block, render string
    [BasicType.TEMPLATE]: Template,
    [BasicType.ACCORDION]: Accordion,
    [BasicType.ACCORDION_ELEMENT]: AccordionElement,
    [BasicType.ACCORDION_TITLE]: AccordionTitle,
    [BasicType.ACCORDION_TEXT]: AccordionText
};

export type {
    IPage,
    ISection,
    IWrapper,
    IColumn,
    IGroup,
    IText,
    ITable,
    IImage,
    IButton,
    IDivider,
    ISpacer,
    ICarousel,
    IHero,
    ISocial,
    INavbar,
    IRaw,
    IAccordion,
    IAccordionElement,
    IAccordionTitle,
    IAccordionText,
    ITemplate,
    ITableColumn,
    ITableRow
};
